import { VIEWER_SET_SHOW_SEED_LIST } from '../actions';

export default function setShowSeedList(showSeedList) {
  return {
    type: VIEWER_SET_SHOW_SEED_LIST,
    showSeedList,
  };
}
